export function isReadOnly(cmp_data, formState = '') {
    let cmp_state = cmp_data.cmp_state || formState;
    return cmp_data[cmp_state + 'displaystate'] === 'readonly';
}

export function isInvisible(cmp_data, formState = '') {
    let cmp_state = cmp_data.cmp_state || formState;
    return cmp_data[cmp_state + 'displaystate'] === 'invisible';
}



// WEBPACK FOOTER //
// ./src/components/util/componetState.js